import { render } from "./PercentChangeIndicator.vue?vue&type=template&id=c0f66caa&scoped=true"
import script from "./PercentChangeIndicator.vue?vue&type=script&lang=js"
export * from "./PercentChangeIndicator.vue?vue&type=script&lang=js"

import "./PercentChangeIndicator.vue?vue&type=style&index=0&id=c0f66caa&lang=scss&scoped=true"

import exportComponent from "/var/www/production/releases/343/listings.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0f66caa"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
